import { render, staticRenderFns } from "./IndexProdItem.vue?vue&type=template&id=77b9867a&scoped=true&"
import script from "./IndexProdItem.vue?vue&type=script&lang=js&"
export * from "./IndexProdItem.vue?vue&type=script&lang=js&"
import style0 from "./IndexProdItem.vue?vue&type=style&index=0&id=77b9867a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b9867a",
  null
  
)

export default component.exports